import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchTermPaymentRecords,
    fetchTermPaymentRecordsFail,
    fetchTermPaymentRecordsSuccess,
    resetState
} from './report.action';
import { TermPayment } from './report.model';

export interface ReportRecordsState {
    termPaymentData: TermPayment[];
    termPaymentsTotal: number;
    termPaymentLoading: boolean;
    termPaymentError: any;
}

export const initialState: ReportRecordsState = {
    termPaymentData: [],
    termPaymentsTotal: 0,
    termPaymentLoading: false,
    termPaymentError: null
};

export const ReportRecordReducer = createReducer(

    initialState,
    
    on(fetchTermPaymentRecords, (state) => {
        return { ...state, termPaymentLoading: true, termPaymentError: null };
    }),
    on(fetchTermPaymentRecordsSuccess, (state, { termPaymentData, termPaymentsTotal }) => {
        return { ...state, termPaymentData, termPaymentsTotal, termPaymentLoading: false };
    }),
    on(fetchTermPaymentRecordsFail, (state, { termPaymentError }) => {
        return { ...state, termPaymentError, termPaymentLoading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);